import React from "react";
import { SegmentedControl, Loader } from "@mantine/core";

const ArtTabs = ({ activeTab, setActiveTab, language, movies, books, games }) => {
  const tabs = [
    { key: "movie", label: language === "ru" ? "Фильмы" : "Movies", data: movies },
    { key: "book", label: language === "ru" ? "Книги" : "Books", data: books },
    { key: "videoGame", label: language === "ru" ? "Игры" : "Games", data: games },
  ];

  const data = tabs.map((tab) => {
    const isLoading = tab.data === null;
    const count = tab.data?.length;
    const suffix = isLoading ? " …" : count !== undefined ? ` (${count})` : "";
    return { label: tab.label + suffix, value: tab.key };
  });

  return (
    <div className="flex justify-center">
      <SegmentedControl
        value={activeTab}
        onChange={setActiveTab}
        data={data}
        radius="xl"
        size="sm"
      />
    </div>
  );
};

export default ArtTabs;
